module.exports = __webpack_public_path__ + "img/icon_reimbursement_direct_payment.51ac9cd4.svg";